import Const from 'const';
import {LateSwapSimplexLineupsInterface} from 'components/organisms/late-swap/late-swap-interfaces';
import SimplexLineup from 'models/simplex-lineup';

class LateSwapSimplexLineups implements LateSwapSimplexLineupsInterface {
    private indexedByEntryId: {} = {};
    constructor(public readonly simplexLineups: SimplexLineup[] = []) {
        simplexLineups.map((simplexLineup) => {
            this.indexedByEntryId[simplexLineup.getEntryId()] = simplexLineup;
        });
    }
    getOneByEntryId(entryId: string): SimplexLineup | null {
        if (this.indexedByEntryId.hasOwnProperty(entryId)) {
            return this.indexedByEntryId[entryId];
        }

        return null;
    }
    getAllAsArr(): SimplexLineup[] {
        return Object.values(this.indexedByEntryId);
    }
    hasLineups(): boolean {
        return !isEmpty(this.indexedByEntryId);
    }
}

const lateSwapSimplexLineups = new LateSwapSimplexLineups();

export default function (state = lateSwapSimplexLineups, action) {
    switch (action.type) {
        case Const.LATESWAP_SET_SIMPLEX_LINEUPS:
            return new LateSwapSimplexLineups(action.lineups);

        case Const.FILTER_BY_SLATE:
            return new LateSwapSimplexLineups();

        default:
            return state;
    }
}
